<template>
  <div>
    <list row-key="PlaceId" ref="list" unit="激活名额" :expand-all-row="true" :page="page" :query-params="params"
      :show-checkbox="$permission.canDel()" :show-query="showQuery"
      :get-data-func="api.list" @reset="reset">
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="query">
        <el-form-item label="归属机构">
          <tree-select ref="treeSelect" :props="props" :options="TreeData" :value="null"
            :clearable="true" :accordion="true" :parentSelect="true" placeholder="请选择"
            @node-select="onTreeSelect($event)" />
        </el-form-item>
        <el-form-item label="项目">
          <el-select v-model="params.Item" clearable>
            <el-option value="实操" />
            <el-option value="模拟" />
            <el-option value="课堂" />
          </el-select>
        </el-form-item>
        <el-form-item label="操作日期" v-if="loginInfo.UserType!=1">
          <el-date-picker v-model.trim="params.DateStart" placeholder="请选择日期" value-format="yyyy-MM-dd"
            style="width: 180px"></el-date-picker>
          <span style="margin:0 10px;">-</span>
          <el-date-picker v-model.trim="params.DateEnd" placeholder="请选择日期" value-format="yyyy-MM-dd"
            style="width: 180px"></el-date-picker>
        </el-form-item>
        <el-form-item label="操作类型">
          <el-select v-model="params.PlaceType" placeholder="请选择操作类型" clearable>
            <el-option label="购买" :value="1"></el-option>
            <el-option label="回收" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="培训车型">
          <el-select v-model="params.CarType" clearable multiple filterable>
            <el-option v-for="item in carTypeList" :key="item.DataName" :value="item.DataName" />
          </el-select>
        </el-form-item> -->
      </template>
      <template slot="table">
        <el-table-column prop="DpName" label="归属机构" min-width="150" />
        <el-table-column prop="Item" label="项目" />
        <el-table-column prop="PlaceDate" label="操作日期" min-width="110" v-if="loginInfo.UserType!=1">
          <template slot-scope="{row}">
            {{$commonJs.toDateString(row.PlaceDate)}}
          </template>
        </el-table-column>
        <el-table-column prop="PlaceType" label="操作类型">
          <template slot-scope="{row}">
            <span v-if="row.PlaceType==1">购买</span>
            <span v-else>回收</span>
          </template>
        </el-table-column>
        <el-table-column prop="Quantity" label="数量" />
        <el-table-column prop="Status" label="审批状态" width="90" align="center">
          <template slot-scope="{row}">
            <el-tag type="info" v-if="row.Status==0">草稿</el-tag>
            <el-tag type="warning" v-else-if="row.Status==1">待审批</el-tag>
            <el-tag type="danger" v-else-if="row.Status==2">退回</el-tag>
            <el-tag type="success" v-else-if="row.Status==3">已审批</el-tag>
          </template>
        </el-table-column>
        <!-- slot[column] -->
        <slot name="column"></slot>
        <!--/ slot[column]-->
      </template>
    </list>
  </div>
</template>
<script>
  var loginInfo = JSON.parse(localStorage.getItem("loginInfo"));
  import listMixin from "@/mixins/list";
  import list from "@/components/common/list";
  import treeSelect from "@/components/common/treeSelect";

  export default {
    mixins: [listMixin],
    components: { list, treeSelect },
    data() {
      return {
        api: require("@/api/op/activeplace").default,
        basicApi: require("@/api/basic/data").default,
        dpApi: require("@/api/basic/dp").default,
        params: {
          Status: null,
          DpIdChain: "",
          PlaceType: null,
          // CarType: null,
          DateStart: null,
          DateEnd: null,
          Item: "",
        },
        props: {
          value: "DpId",
          label: "DpName",
          children: "children",
        },
        loginInfo,
        TreeData: [],
        // carTypeList: [],//车型
      };
    },
    beforeMount() {
      this.dpApi.getAuthList({ DpTypes: [2,3,4], Status: 3, NoReturnParent: true }).then((res) => {
        this.TreeData = this.$commonJs.toTreeData(res.Data, "DpId");
      });
      // this.basicApi.list({ ClassName: "培训车型", Status: 1 }).then(res => {
      //   this.carTypeList = res.Data
      // });
    },
    methods: {
      onTreeSelect(t) {
        if (!t) {
          this.params.DpIdChain = "";
        } else {
          this.params.DpIdChain = t.IdChain;
        }
      },
      onExport() {
        this.api.export(this.$commonJs.obj.removeNullKey(this.$refs.list.tempQueryParams));
      },
      reset() {
        this.$refs.treeSelect.clearHandle();
      },
      delRange(Ids) {
        this.api.delete({ Ids }).then((res) => {
          if (res.Code == 0) {
            this.$message.success("删除成功");
            this.reload();
          } else {
            this.$message.error(res.Msg);
          }
        });
      },
    },
  };
</script>